import { ReduxService } from 'dashboard-services/services';

import { pdfViewerActions } from 'actions/modules/tools';

export const pdfViewerInitialState = {
  open: false,
  fileId: undefined,
  provider: undefined
}

export default (state = pdfViewerInitialState, action) => {

  switch (action.type) {
    case pdfViewerActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}